import axios from "axios";

export default function handoffWarrantyClaim(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/consumer/admin/api/v1/prife/claim/${parameters.id}/submit-hq-review`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
